import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state={
  u_token:'',
  u_id:'',
  name:'',
  photo:'',
  sex:'',
  phone:'',
  email:'',
  signature:'',
  shop_type:'',
  //
  a_token:'',
  a_id:'',
  Aname:'',
  Aphoto:'',
  a_type:''
}

const mutations={
  //普通用户
  changeUserInfor(state,payload){
    state.u_token=payload.u_token;
    state.u_id=payload.u_id;
    state.name=payload.name;
    state.photo=payload.photo;
    state.sex=payload.sex;
    state.phone=payload.phone;
    state.email=payload.email;
    state.signature=payload.signature;
    state.shop_type=payload.shop_type;
  },
  changeUserInfor_no_token(state,payload){
    state.u_id=payload.u_id;
    state.name=payload.name;
    state.photo=payload.photo;
    state.sex=payload.sex;
    state.phone=payload.phone;
    state.email=payload.email;
    state.signature=payload.signature;
    state.shop_type=payload.shop_type;
  },
  //管理员
  changeAdminInfor(state,payload){
    state.a_token=payload.a_token;
    state.a_id=payload.a_id;
    state.a_type=payload.a_type;
  },
  //管理员name和photo
  change_Admin_Name_Photo(state,payload){
    state.Aname=payload.Aname;
    state.Aphoto=payload.Aphoto;
  },
}

export default new Vuex.Store({
  state,
  mutations,
})



// WEBPACK FOOTER //
// ./src/vuex/Cookie_vuex.js